<svelte:options tag={null} />

<script lang="ts">
  import type { HeroProps } from './hero.type';

  export let image: HeroProps['image'];
  export let altImage: HeroProps['altImage'];
  export let title: HeroProps['title'];
  export let centered: HeroProps['centered'] = false;
  export let hascontent = false;

  const hasSlot = !!($$slots && Object.keys($$slots).length);
</script>

<div class={`mc-hero ${centered ? 'mc-hero--center' : ''}`} {...$$restProps}>
  <div class="ml-container ml-container--fluid">
    <div class="ml-flexy ml-flexy--gutter">
      <div class="mc-hero__main ml-flexy__col">
        <picture class="mc-hero__cover">
          <img class="mc-hero__visual" src={image} alt={altImage || ''} />
        </picture>

        <div class="mc-hero__header">
          <h1
            class={`mc-hero__title 
            mt-heading
            mt-heading--lightest
            mt-heading--s 
            mt-heading--underline
            ${centered ? 'mt-heading--center' : ''}
            ${hasSlot || hascontent ? 'mc-hero--with-content' : ''}
            `}
          >
            {title}
          </h1>
          {#if hasSlot || hascontent}
            <div class="mc-hero__content mt-body-m">
              <slot />
            </div>
          {/if}
        </div>
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/_all-settings';
  @import '@mozaic-ds/styles/typography/_t.all-base-typography';
  @import '@mozaic-ds/styles/layouts/_l.container';
  @import '@mozaic-ds/styles/layouts/_l.flexy';
  @import '@mozaic-ds/styles/components/_c.hero';

  p:global() {
    margin-bottom: 0;
    margin-top: 0;
  }
</style>
